module.exports = __webpack_public_path__ + "img/tit-ja.48ec1a36.svg";